export const ADMINMODE = false

export const URL = process.env.REACT_APP_URL
export const DOMAIN = process.env.REACT_APP_DOMAIN

// Diagnostic warnings for missing environment variables
if (!URL && process.env.NODE_ENV !== 'test') {
  console.warn('⚠️ REACT_APP_URL is not defined. API calls may fail.');
}
if (!DOMAIN && process.env.NODE_ENV !== 'test') {
  console.warn('⚠️ REACT_APP_DOMAIN is not defined. Image URLs may be malformed.');
}
